var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWaterfall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 5.75c0 .467 0 .701-.1.875a.75.75 0 0 1-.275.275C8.701 7 8.467 7 8 7s-.701 0-.875-.1a.75.75 0 0 1-.275-.275c-.1-.174-.1-.408-.1-.875V2h2.5v3.75zM11.5 9.25c0 .414.336.75.75.75h1a.75.75 0 0 0 .75-.75V2h-2.5v7.25zM2.75 6a.75.75 0 0 0-.75.75V14h2.5V6.75A.75.75 0 0 0 3.75 6h-1z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWaterfall);
export default ForwardRef;